/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IVideoUserPreferencesHttpService } from './video-user-preferences-http.service.interface';
import { IVideoUserPreferences } from './video-user-preferences.interface';

@Injectable()
export class VideoUserPreferencesHttpService implements IVideoUserPreferencesHttpService {
  constructor(private readonly _httpClient: HttpClient) {}

  getUserPreferences(): Observable<IVideoUserPreferences> {
    return this._httpClient.get<IVideoUserPreferences>(`${environment.config.videoExperienceApiBaseUrl}/v1/userpreferences`);
  }
}
